module.exports = __webpack_public_path__ + "img/trending-down-blue.170686fd.svg";